export default __webpack_public_path__ + "static/media/821.f8d2a664.png";